export const formatPhoneNumber = (num) => {
    const maxLen = 12

    // Проверяем, существует ли значение num и не является ли оно пустым
    if (!num) {
        return num
    }

    // Оставляем только цифры и знак "+"
    num = num.replace(/[^\d+]/g, "")

    // Убедимся, что номер начинается с "+"
    if (num.charAt(0) !== "+") {
        num = "+" + num
    } else {
        num = '+' + num.slice(1, maxLen).replace(/\+/g, "")
    }

    // Меняем +8 на +7 и ограничиваем длину до 12 символов
    return num.replace(/\+8/, "+7").replace(/\+9/, "+79").slice(0, maxLen)
}

export const isPhoneValid = (num) => {
  const numString = num.toString().replace(/[^\d+]/g, "")

  if (numString.length === 0) {
    return true;
  }
  return numString.length >= 11
};
